<a href="https://github.com/MartinFreire/angular-multi-level-form/tree/master/src/app/{{path}}" target="_blank">
  <button mat-mini-fab color="primary">
    <mat-icon color="accent">code</mat-icon>
  </button>
</a>
